import React from "react";
import { Column } from "react-table";
import { Box } from "@chakra-ui/react";

import { Table } from "@alpacahq/alpaca-component-library";

import { AcatsContraBroker } from "../../../api/acats/listAcatsContraBrokers";

const DEFAULT_PAGE_SIZE = 100;

interface AcatsContraBrokersTableProps {
  data: AcatsContraBroker[];
  filters: { [key: string]: unknown };
  isLoading: boolean;
  query: string;
}

const AcatsContraBrokersTable = ({
  data,
  filters,
  isLoading,
  query,
}: AcatsContraBrokersTableProps): JSX.Element => {
  const columns: Column<AcatsContraBroker>[] = [
    {
      id: "name",
      accessor: "name",
      Header: "Name",
    },
    {
      id: "number",
      accessor: "number",
      Header: "DTC Number",
    },
    {
      id: "type",
      accessor: "type",
      Header: "Type",
    },
  ];

  return (
    <Box p="1rem">
      <Table
        columns={columns}
        data={data}
        defaultPerPage={DEFAULT_PAGE_SIZE}
        filterByColumnValues={filters}
        filterGlobalValue={query}
        filterGlobalColumns={["name", "number"]}
        isLoading={isLoading}
        pagination
        paginationPosition="top"
      />
    </Box>
  );
};

export default AcatsContraBrokersTable;
